import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { getAkHashDescription } from '../api';
import { setIndustryName } from '../actions/application';

const useGetIndustry = (akHash?: string) => {
  const dispatch = useDispatch();

  return useQuery(['industry_name', akHash], () => getAkHashDescription(akHash), {
    enabled: Boolean(akHash),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    select: (data) => data.data as string,
    onSuccess: (name: string) => {
      dispatch(setIndustryName(name));
    },
  });
};

export default useGetIndustry;
